import { render } from "./vendor_invoices.vue?vue&type=template&id=63adf332"
import script from "./vendor_invoices.vue?vue&type=script&lang=js"
export * from "./vendor_invoices.vue?vue&type=script&lang=js"

import "./vendor_invoices.vue?vue&type=style&index=0&id=63adf332&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__